export default __webpack_public_path__ + "static/email-templates-copy-signature-23878b440b774d961ca8bc89d86372e6.mp4";